import { cpOrderFormApiConnector } from 'apiConnector/secondary-market/cp-order/form';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators';
import {
  secondaryMarketCpOrderPlacementFailedThunk,
  secondaryMarketCpOrderPlacementReceivedThunk,
} from 'state/secondaryMarket/cpOrder/order/order.thunks';
import type { EpicWithThunk } from 'state/state.common';
import type { HttpError } from 'utils/http/httpClient.model';
import { extractHttpErrorMessage, extractTimeout, isHttpTimeoutError } from 'utils/http/httpClient.model';

import { getTabRemoved$ } from '../utils';

export function placeOrderEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) => {
    const { placeOrder } = cpOrderFormApiConnector(httpClient);

    return actions$.pipe(
      ofType('SECONDARY_MARKET_CP_ORDER_PLACEMENT_REQUESTED'),
      mergeMap(({ tabId, request }) => {
        return placeOrder(request).pipe(
          takeUntil(getTabRemoved$(actions$, tabId)),
          map(response => secondaryMarketCpOrderPlacementReceivedThunk(tabId, response)),
          catchError((err: HttpError) => {
            return of(
              secondaryMarketCpOrderPlacementFailedThunk(
                tabId,
                isHttpTimeoutError(err),
                extractHttpErrorMessage(err, { backend: 'domino' }),
                extractTimeout(err),
              ),
            );
          }),
        );
      }),
    );
  };
}
